module.exports = __webpack_public_path__ + "static/toyota-102ba4469b25ae515d2d377714ca8a4d.jpg";